import React, { useState } from 'react'
import { Menu } from '@material-ui/core'
import { CustomArrowDown, FilterWrapper } from '../../../styles'
import { StyledMenuItem } from '../../../../../../theme/Global'

export const FilterableTableHeader = ({ field, text, selection, filterOptions, eventHandlers }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const filterClick = (selected) => {
    const newFilterOptions = {}
    Object.keys(filterOptions).forEach( (field) => newFilterOptions[field] = { ...filterOptions[field] })

    if (selected[1] === '') {
      newFilterOptions[field] = {
        filter: undefined,
        display: undefined
      }
    } else {
      newFilterOptions[field] = {
        filter: selected[1],
        display: selected[0]
      }
    }

    eventHandlers.setFilterOptions(newFilterOptions)
    eventHandlers.setPageNumber(1)

    setAnchorEl(null)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <span>
      <span
        data-testid={`filterable-table-header-${field}`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {text}
        {filterOptions.hasOwnProperty(field) && filterOptions[field].filter !== undefined
          ? (
            <FilterWrapper data-testid={`filterable-table-header-${field}`}>
              {CustomArrowDown}
            </FilterWrapper>
          )
          : null}
      </span>
      {selection !== undefined ? (
        <Menu
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          getContentAnchorEl={null}
          MenuListProps={{ style: { maxHeight: '40vh' } }}
        >
          {selection.map((selected) => (
            <StyledMenuItem
              data-testid="filter-header-menu-item"
              key={`${field}-${selected[1]}`}
              onClick={() => filterClick(selected)}
              data-filter={selected[1]}
            >
              {selected[0]}
            </StyledMenuItem>
          ))}
        </Menu>
      )
        : null}
    </span>
  )
}
